export default __webpack_public_path__ + "static/media/TensileStressImg.59e271af.png";